module.exports = __webpack_public_path__ + "static/media/colissimo.f3a3b1b5.svg";